<script>

export let item

</script>

<a class="hover:bg-gray-200 rounded block flex flex items-center p-2" href={item.url}>
    <div class="relative p-2 flex flex-col justify-center">
        <img class="h-20 w-20  object-contain" src={item.logo} alt={item.name}>
    </div>
    <div class="flex flex-col ml-2">
        <div class="font-bold text-xl">{item.name}</div>
        <div class=" text">{item.description}</div>
    </div>
</a>